import { render, staticRenderFns } from "./IconSvgZip.vue?vue&type=template&id=534dc068&scoped=true&"
import script from "./IconSvgZip.vue?vue&type=script&lang=js&"
export * from "./IconSvgZip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534dc068",
  null
  
)

export default component.exports